export default __webpack_public_path__ + "static/media/breakfast_18.204e1393.jpg";